<template>
        <div class="">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <a href="javascript:void(0)">Change Plant</a></li>
                </ol>
                <h4 class="main-title mb-2">Plants</h4>
            </div>
            <div class="row g-2">
                <div class="col-12">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title">Plants</h6>
                        </div>
                        <div class="card-body">
                            <input class="form-control form-control-sm mb-2" type="text"
                                placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()"/>
                            <div class="table-responsive table-responsive-sm">
                                <table class="table table-sm text-nowrap table-striped table-bordered mb-0">
                                    <thead>
                                        <tr style="background-color: #9b9b9b; color: white;">
                                            <th class="text-center">#</th>
                                            <th @click="sort('plant_name')">Plant
                                                <span>
                                                    <i v-if="meta.keyword=='plant_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                    <i v-else-if="meta.keyword=='plant_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                                </span>
                                            </th>
                                            <th class="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="plants.length==0">
                                            <td colspan="5" class="text-center">No records found</td>
                                        </tr>
                                        <tr v-for="plant, key in plants" :key="key">
                                            <td class="text-center">{{ meta.from + key }}</td>
                                            <td>{{ plant.plant_name }}</td>
                                            <td class="text-center">    
                                                <a class="btn btn-success btn-sm px-2 py-1" @click="updateChangePlant(plant)">Change Plant</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex justify-content-between align-items-center">
                                <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                    <option>10</option>
                                    <option>15</option>
                                    <option>20</option>
                                    <option>25</option>
                                    <option>30</option>
                                </select>
                                <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                                <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination
        },
        data() {
            return {
                meta: {
                    search: '',
                    order_by: "asc",
                    keyword: "plant_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    plant_id:""
                },
                plants: [],
                status: true,
                errors: [],
                update: false
            }
        },
        mounted() {
            this.create_role = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('roles.create')
            })
            this.index();
        },
    
        methods: {
            index() {
                let vm = this;
                let loader = this.$loading.show();
                this.$store.dispatch('post', { uri: 'paginateChangePlants' , data:vm.meta })
                    .then(response => {
                        loader.hide();
                        this.plants = response.data.data;
                        this.meta.totalRows = response.data.meta.total;
                        this.meta.from = response.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        this.meta.lastPage = response.data.meta.last_page;
                        this.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
    
            updateChangePlant(plant) {
                let vm = this;
                vm.meta.plant_id = plant.plant_id;
                let loader = vm.$loading.show();
                vm.$store.dispatch('post', { uri: 'updateChangePlant', data: this.meta })
                    .then(response => {
                        loader.hide();
                        let user = vm.$store.getters.user
                        user.plant_id = plant.plant_id
                        user.plant = plant
                        vm.$store.dispatch('setUser', user)
                        vm.$store.dispatch('success', response.data.message);
                    })
                    .catch(function (error) {
                        loader.hide();
                        console.log('errors', error)
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
    
            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            onPerPageChange() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
        }
    }
    </script>